// 서버 FontColors.java와 동일한 고정 팔레트 — 값 변경 시 양쪽을 함께 수정할 것
export const FONT_COLOR_PALETTE = [
    { name: '검정', hex: '#000000' },
    { name: '파랑', hex: '#1971C2' },
    { name: '빨강', hex: '#E03131' },
    { name: '보라', hex: '#9C36B5' },
    { name: '초록', hex: '#2F9E44' },
    { name: '갈색', hex: '#795548' },
    { name: '주황', hex: '#E8590C' },
    { name: '청록', hex: '#0C8599' },
    { name: '로즈', hex: '#D6336C' },
    { name: '인디고', hex: '#3B5BDB' },
    { name: '바이올렛', hex: '#6741D9' },
    { name: '라임', hex: '#5C940D' },
    { name: '에메랄드', hex: '#099268' },
    { name: '와인', hex: '#A61E4D' },
    { name: '연분홍', hex: '#FAA2C1' },
    { name: '하늘', hex: '#74C0FC' },
    { name: '살구', hex: '#FFC078' },
    { name: '더스티로즈', hex: '#C08497' },
    { name: '라벤더', hex: '#9775FA' },
];

export const DEFAULT_FONT_COLOR = '#000000';
